import React, {Component, createRef} from 'react';
import { responsiveFontSize } from '../Services/Utilities';

const DEFAULT_STROKE_WIDTH = 1
const DEFAULT_STROKE_COLOR = '#006080'
const DEFAULT_DASHED_COLOR = 'orange'

const DEFAULT_CONNECTION_LINE_STROKE_WIDTH = 2
const DEFAULT_CONNECTION_LINE_COLOR = 'rgba(0, 96, 128, 0.5)'

const DEFAULT_SLIDER_DOT_COLOR = 'rgba(0, 96, 128, 0.5)'

const DEFAULT_TIP_SIZE = 10
const N_STEPS = 6

class ChartModalSliders extends Component {
    
    constructor(props){
        super(props)
        
        this.canvasRef = createRef()

        this.state = {
            ctx: undefined,
            allowDrawing: false,

            canvasHeight:0,
            canvasWidth:0,

            cursorType:'default',

            firstPoint:[/*x, y, size*/],
            secondPoint:[/*x, y, size */],
            thirdPoint:[/*x, y, size */],
            middlePoint: [/*x, y, size */],

            controlledPoint: 'firstPoint',

            clickablePoints: ['firstPoint', 'secondPoint', 'thirdPoint'],
            clickableAreaPoints: ['firstPoint_base', 'secondPoint_base', 'thirdPoint_base'],
            VerticalPoints: ['firstPoint', 'secondPoint', 'thirdPoint'],
            IsMovingPoint:false,

            indexMapping:{
                firstPoint:0,
                secondPoint:1,
                thirdPoint:2,
            },

            offset:0
        }

        this.drawPlot = this.drawPlot.bind(this)
        this.drawAxes = this.drawAxes.bind(this)

        this.computePointInCanvas = this.computePointInCanvas.bind(this)
        this.handleMouseClick = this.handleMouseClick.bind(this)
        this.handleMouseMove = this.handleMouseMove.bind(this)

        this.setCursorAsPointer = this.setCursorAsPointer.bind(this)

        this.getCoordinates = this.getCoordinates.bind(this)
        this.getCoordinatesSlider = this.getCoordinatesSlider.bind(this)

        this.drawLine = this.drawLine.bind(this)
        this.drawMiddleLine = this.drawMiddleLine.bind(this)
        this.drawPoint = this.drawPoint.bind(this)
        this.drawSlider = this.drawSlider.bind(this)

    }

    componentDidMount(){
        if(this.canvasRef){
            let ctx = this.canvasRef.current.getContext('2d')

            let strokeWidth = this.props.strokeWidth || DEFAULT_STROKE_WIDTH
            let strokColor = this.props.strokColor || DEFAULT_STROKE_COLOR

            const { width, height} = this.props.style;

            let offset = DEFAULT_TIP_SIZE

            let firstPoint = [offset + DEFAULT_TIP_SIZE, offset + DEFAULT_TIP_SIZE, DEFAULT_TIP_SIZE]
            let firstPoint_base = [...firstPoint]

            let secondPoint = [offset + width/2, offset + height/2 , DEFAULT_TIP_SIZE]
            let secondPoint_base = [...secondPoint]

            let thirdPoint = [offset + width - DEFAULT_TIP_SIZE , offset + height - DEFAULT_TIP_SIZE, DEFAULT_TIP_SIZE]
            let thirdPoint_base = [...thirdPoint]

            this.setState({
                ctx: ctx,
                allowDrawing: true,
                strokeWidth:strokeWidth,
                strokColor: strokColor,

                canvasWidth: width,
                canvasHeight: height,

                controlPointX: width/2,
                controlPointY: height/2,

                firstPoint: firstPoint,
                firstPoint_base: firstPoint_base,
                
                secondPoint: secondPoint,
                secondPoint_base: secondPoint_base,
                
                thirdPoint: thirdPoint,
                thirdPoint_base: thirdPoint_base,

                middlePoint: [offset + width/2, offset + height/2, 0],

                offset: offset
            }, () => {
                const {Father} = this.props
                
                Father.setState({
                    SlidersValues:[190,0,-190],
                })

                this.drawPlot()
            })

            
        }
    }

    drawPlot() {
        const {ctx} = this.state;
        if(!ctx) return;      

        const { canvasWidth, canvasHeight, strokColor, strokeWidth, offset} = this.state;

        const {firstPoint, secondPoint, thirdPoint, middlePoint} = this.state;
        const {firstPoint_base, secondPoint_base, thirdPoint_base} = this.state;

        //clean the drawing 
        ctx.clearRect(0, 0, canvasWidth + offset * 2, canvasHeight + offset * 2);

        //draw first point + slider
        this.drawPoint(firstPoint, DEFAULT_CONNECTION_LINE_COLOR, '#d9d9d9')
        this.drawSlider(firstPoint_base, canvasHeight)

        //draw second point
        this.drawPoint(secondPoint, DEFAULT_CONNECTION_LINE_COLOR, '#d9d9d9')
        this.drawSlider([secondPoint_base[0], firstPoint_base[1], secondPoint_base[2]], canvasHeight)

        //draw third point
        this.drawPoint(thirdPoint, DEFAULT_CONNECTION_LINE_COLOR, '#d9d9d9')    
        this.drawSlider([thirdPoint_base[0], firstPoint_base[1], thirdPoint_base[2]], canvasHeight)

        //connect lines
        this.drawLine(firstPoint, secondPoint)
        this.drawLine(middlePoint, thirdPoint)
        this.drawMiddleLine(secondPoint, middlePoint)

        //draw x axis
        this.drawAxes()
        

    }

    drawPoint(point, color, fillColor){
        const {ctx} = this.state;
        if(!ctx) return;      

        ctx.beginPath();
        ctx.arc(point[0], point[1], point[2], 0, 2 * Math.PI);
        ctx.strokeStyle = color;
        ctx.fillStyle = fillColor;
        ctx.fill();
        ctx.stroke();

        ctx.beginPath();
        ctx.arc(point[0], point[1], DEFAULT_TIP_SIZE*0.3, 0, 2 * Math.PI);
        ctx.strokeStyle = DEFAULT_CONNECTION_LINE_COLOR;
        ctx.fillStyle = DEFAULT_CONNECTION_LINE_COLOR;
        ctx.fill();
        ctx.stroke();
    }

    drawLine(startPoint, endPoint, dashed, alignmentColor = DEFAULT_DASHED_COLOR){
        const {ctx} = this.state;
        if(!ctx) return;      

        let isHorizontal = this.isHorizontalLine(startPoint, endPoint)

        ctx.beginPath();

        ctx.moveTo(...startPoint);
        ctx.lineTo(...endPoint);

        ctx.strokeStyle = (isHorizontal) ? alignmentColor : DEFAULT_CONNECTION_LINE_COLOR;
        ctx.lineWidth = DEFAULT_CONNECTION_LINE_STROKE_WIDTH 

        ctx.stroke();
        ctx.setLineDash([])
    }

    drawMiddleLine(startPoint, endPoint){
        const {ctx} = this.state;
        if(!ctx) return;      

        ctx.beginPath();

        ctx.moveTo(...startPoint);
        ctx.lineTo(...endPoint);

        ctx.strokeStyle = 'red';
        ctx.lineWidth = DEFAULT_CONNECTION_LINE_STROKE_WIDTH 

        ctx.stroke();
        ctx.setLineDash([])
    }

    drawAxes(){
        const {canvasWidth, canvasHeight, ctx, offset} = this.state
        if(!ctx) return;      

        //x-axis
        ctx.beginPath();

        ctx.moveTo(0, offset +canvasHeight/2);
        ctx.lineTo(2*offset + canvasWidth, offset + canvasHeight/2);

        ctx.strokeStyle = 'rgba(0, 0, 0, 0.25)'
        ctx.lineWidth = 1;

        ctx.stroke();
    }

    drawSlider(point, length){
        const {ctx} = this.state;
        if(!ctx) return;  

        let step = (length - 2*point[2])/N_STEPS

        /*ctx.beginPath();
        ctx.rect(point[0] - point[2], point[1] - point[2], 2*point[2],length);
        ctx.strokeStyle = DEFAULT_SLIDER_BORDER_COLOR;
        ctx.strokeWidth = DEFAULT_SLIDER_STROKE_WIDTH
        ctx.stroke();*/

        for(let i = 0; i < (step+1); i++){
            ctx.beginPath();
            ctx.arc(point[0], point[1] + i * step, DEFAULT_TIP_SIZE*0.15, 0, 2 * Math.PI);
            ctx.strokeStyle = DEFAULT_SLIDER_DOT_COLOR;
            ctx.fillStyle = DEFAULT_SLIDER_DOT_COLOR;
            ctx.fill();
            ctx.stroke();
        }

        ctx.beginPath();
        ctx.moveTo(point[0], point[1]);
        ctx.lineTo(point[0], length);

        ctx.lineWidth = 2;
        ctx.strokeStyle = 'rgba(0, 0, 0, 0.25)';
        ctx.fillStyle = 'rgba(0, 0, 0, 0.25)';

        ctx.stroke();
    }
    
    handleMouseClick(e){
        const {controlledPoint, canvasHeight, offset, indexMapping} = this.state
        let position = 0

        if(controlledPoint){
            const point = this.computePointInCanvas(e.clientX, e.clientY);
            let range = canvasHeight - 2*offset
            let sliderRange = canvasHeight
            let step = (range)/N_STEPS

            position = Math.floor(point.y/step) * step + 2*offset
            let newPoint = this.state[controlledPoint] 

            newPoint[1] = position 

            let data = this.state
            data[controlledPoint] = newPoint

            this.setState(
            ({...data}),

            () => {
                //Update drawing
                this.drawPlot()

                //Update slider values for Clickable question
                let father = this.props.Father

                if(father){
                    let index = indexMapping[controlledPoint] 

                    let slidersValues = father.state.SlidersValues

                    slidersValues[index] =  sliderRange/2 - position + offset

                    father.setState({
                        SlidersValues:slidersValues
                    }, () => console.log(father))
                }
            })

        }
    }

    handleMouseMove(e){
        const point = this.computePointInCanvas(e.clientX, e.clientY);
        let hoverPoint = this.setCursorAsPointer(point)

        if(hoverPoint){
           
            this.setState({
                controlledPoint: hoverPoint,
                cursorType: 'pointer'
            })
        }
        else{
            this.setState({
                controlledPoint: null,
                cursorType: 'default'
            })
        }
    }

    setCursorAsPointer(mousePosition){
        const {clickableAreaPoints} = this.state

        for(let clickablePoint of clickableAreaPoints){

            let coordinates = this.getCoordinatesSlider(clickablePoint)
            if(this.checkPointInsideRect(mousePosition, coordinates)){
                return clickablePoint.replace('_base', '')
            }
        }

        return null
    }
    
    getCoordinates(pointName){
        const data = this.state[pointName]

        // x - size, x + size, y - size, y + size
        return({
            x1: data[0] - data[2],
            x2: data[0] + data[2],
            y1: data[1] - data[2],
            y2: data[1] + data[2]
        })
    }

    getCoordinatesSlider(pointName){
        const data = this.state[pointName]
        const {canvasHeight , firstPoint_base} = this.state

        // x - size, x + size, y - size, y + size
        return({
            x1: data[0] - data[2],
            x2: data[0] + data[2],
            y1: firstPoint_base[1] - data[2] ,
            y2: firstPoint_base[1]- data[2] + canvasHeight
        })
    }

    checkPointInsideRect (point, rect){
        return(point.x > rect.x1 && point.x < rect.x2 && point.y > rect.y1 && point.y < rect.y2)
    }


    computePointInCanvas(clientX, clientY) {
        const boundingRect = this.canvasRef.current.getBoundingClientRect();
            return {
                x: Math.floor(clientX - boundingRect.left),
                y: Math.floor(clientY - boundingRect.top)
            }
    }


    isHorizontalLine(firstPoint, secondPoint){
        return (firstPoint[1] == secondPoint[1])
    }

    render(){
        return (
            <div style = {{flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center'}}>
                <div 
                className= {this.props.borderClass || "border"}
                style = {{
                    flexDirection:'column', display:'flex', alignItems:'center', alignContent:'center'}}>
                    <canvas
                        style = {{
                            ...this.props.style, cursor: this.state.cursorType,
                            height:this.props.style.height + this.state.offset * 2,
                            width:this.props.style.width + this.state.offset * 2
                        }}

                        width = {this.props.style.width + this.state.offset * 2}
                        height = {this.props.style.height + this.state.offset * 2}

                        ref = {this.canvasRef}

                        onMouseMove = {this.handleMouseMove}
                        onMouseLeave = {() => this.setState({cursorType:'default'})}
                        onClick = {this.handleMouseClick}
                    />
                </div>
                <p style = {{textAlign:'center'}}>{this.props.title}</p>
            </div>
        );
    }
}

export default ChartModalSliders